/** @format */

import { BreakPointMinWidthValues } from '@shared/data-access/enums';

export const DEVICE_BREAKPOINT_MEDIA_QUERIES = {
  EXTRA_EXTRA_SMALL: `(max-width: ${BreakPointMinWidthValues.EXTRASMALL - 1}px)`,
  EXTRA_SMALL: `(min-width: ${BreakPointMinWidthValues.EXTRASMALL}px) and (max-width: ${BreakPointMinWidthValues.SMALL - 1}px)`,
  SMALL: `(min-width: ${BreakPointMinWidthValues.SMALL}px) and (max-width: ${BreakPointMinWidthValues.MEDIUM - 1}px)`,
  MEDIUM: `(min-width: ${BreakPointMinWidthValues.MEDIUM}px) and (max-width: ${BreakPointMinWidthValues.LARGE - 1}px)`,
  LARGE: `(min-width: ${BreakPointMinWidthValues.LARGE}px) and (max-width: ${BreakPointMinWidthValues.EXTRALARGE - 1}px)`,
  EXTRA_LARGE: `(min-width: ${BreakPointMinWidthValues.EXTRALARGE}px) and (max-width: ${BreakPointMinWidthValues.EXTRAEXTRALARGE - 1}px)`,
  EXTRA_EXTRA_LARGE: `(min-width: ${BreakPointMinWidthValues.EXTRAEXTRALARGE}px)`,
};
